import {
  VLO_GETPOOL_START,
  VLO_GETMOVILES_START,
  VLO_GETPROPERTIES_START,
  VLO_SETMIMOVIL_START,
  VLO_SETCENSO_START,
} from "../../const/actionTypes";

export const ObtenerPoolVehiculos = (payload) => ({
  type: VLO_GETPOOL_START,
  payload,
});
export const ObtenerVehiculos = (payload) => ({
  type: VLO_GETMOVILES_START,
  payload,
});
export const ObtenerPropiedades = (payload) => ({
  type: VLO_GETPROPERTIES_START,
  payload,
});
export const SetMiMovil = (payload) => ({
  type: VLO_SETMIMOVIL_START,
  payload,
});
export const SetCenso = (payload) => ({
  type: VLO_SETCENSO_START,
  payload,
});
